import { IBackStory } from "@src/components/Backstory";
import bgImg from "../../../../public/images/t19bg.png";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { getRole } from "@src/utils/general";

const Backstory: React.FC<IBackStory> = ({ backStoryData }) => {
  const stories = React.useMemo(
    () => backStoryData?.getBackStory?.filter(Boolean) ?? [],
    [backStoryData]
  );

  const [currentStoryIndex, setCurrentStoryIndex] = React.useState(0);

  React.useEffect(() => {
    if (stories.length === 0) {
      setCurrentStoryIndex(0);
      return;
    }

    setCurrentStoryIndex((prev) =>
      prev >= stories.length ? stories.length - 1 : prev
    );
  }, [stories.length]);

  const currentStory = stories[currentStoryIndex];

  const goToPreviousStory = () => {
    if (stories.length <= 1) return;
    setCurrentStoryIndex((prev) =>
      prev === 0 ? stories.length - 1 : prev - 1
    );
  };

  const goToNextStory = () => {
    if (stories.length <= 1) return;
    setCurrentStoryIndex((prev) =>
      prev === stories.length - 1 ? 0 : prev + 1
    );
  };

  return stories.length > 0 ? (
    <div className="w-full relative overflow-hidden">
      <div className="relative z-10 w-full">
        <div className="absolute inset-0">
          <Image
            src={bgImg}
            alt="background"
            layout="fill"
            className="object-cover object-center"
            onError={(e) => console.log("Background image failed to load:", e)}
            onLoad={() => console.log("Background image loaded successfully")}
          />
        </div>

        <div className="relative z-10 w-full px-4 py-12 sm:px-8 sm:py-16 lg:px-12 lg:py-20">
          <div className="mx-auto w-full max-w-4xl">
            <motion.div
              key={currentStory?.id ?? `story-${currentStoryIndex}`}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.45,
                ease: [0.79, 0.14, 0.15, 0.86],
              }}
              className="flex w-full flex-col justify-center"
            >
              <h2 className="mb-4 text-center font-ntFab text-3xl font-light text-[#FCE2B0] sm:text-4xl md:text-5xl lg:text-6xl">
                {currentStory?.title || "From Neighbors to Soulmates..."}
              </h2>
              <p className="whitespace-pre-line text-center font-ebGaramond text-base font-normal leading-relaxed text-[#FCE2B0] sm:text-lg md:text-xl lg:text-2xl">
                {currentStory?.story || "Our love story begins here..."}
              </p>
              <p className="mb-3 text-center font-ebGaramond text-sm uppercase tracking-[0.3em] text-[#FCE2B0]/80">
                {getRole(currentStory?.role)}
              </p>
            </motion.div>
          </div>
        </div>

        {stories.length > 1 && (
          <div className="relative z-10 mt-2 flex items-center justify-center gap-4 pb-10">
            <button
              type="button"
              aria-label="Previous story"
              className="h-10 w-10 rounded-full border border-[#FCE2B0] text-[#FCE2B0] transition hover:bg-[#FCE2B0] hover:text-[#00234B]"
              onClick={goToPreviousStory}
            >
              ‹
            </button>
            <button
              type="button"
              aria-label="Next story"
              className="h-10 w-10 rounded-full border border-[#FCE2B0] text-[#FCE2B0] transition hover:bg-[#FCE2B0] hover:text-[#00234B]"
              onClick={goToNextStory}
            >
              ›
            </button>
          </div>
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Backstory;
